import {Component} from '@angular/core';
import moment from 'moment';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-dpa',
  imports: [RouterLink],
  templateUrl: './dpa.component.html',
  styleUrl: './dpa.component.scss'
})
export class DpaComponent {
  readonly today: string = moment().format('MMM D YYYY');

}
